import { IntlShape } from "react-intl";
import { FieldValues, UseFormClearErrors, UseFormGetValues, UseFormSetError } from "react-hook-form";

import { isConfirmationAfterQuoting } from "pages/shipper/RequestForm/utils/preferredDeadlineValidation";

export const CONFIRMATION_AFTER_QUOTING_ERROR_PATH = "shipment.confirmation_after_quoting";

export { isConfirmationAfterQuoting };

export function validateDatetimeChain(
  getValues: UseFormGetValues<FieldValues>,
  setError: UseFormSetError<FieldValues>,
  intl: IntlShape,
  clearErrors?: UseFormClearErrors<FieldValues>,
): boolean {
  let isValid = true;

  const quotingDate = getValues("shipment.quoting_deadline_date");
  const quotingTime = getValues("shipment.quoting_deadline_time");
  const confirmationDate = getValues("shipment.confirmation_date");
  const confirmationTime = getValues("shipment.confirmation_time");

  if (quotingDate && confirmationDate) {
    if (!isConfirmationAfterQuoting(quotingDate, quotingTime, confirmationDate, confirmationTime)) {
      setError(CONFIRMATION_AFTER_QUOTING_ERROR_PATH, {
        type: "manual",
        message: intl.formatMessage({
          id: "request-form.validation.confirmationAfterQuoting",
          defaultMessage: "Confirmation date must be after quoting deadline",
        }),
      });
      isValid = false;
    } else {
      clearErrors?.(CONFIRMATION_AFTER_QUOTING_ERROR_PATH);
    }
  }

  return isValid;
}
